import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/es/industrias/medical-devices/md-cro-cardiologia")({
  head: () => buildRouteHead("/es/industrias/medical-devices/md-cro-cardiologia"),
  component: ClinicalIndustry,
});

